export type Volume = {
	volume: number
	unit: VolumeUnit
}

export enum VolumeUnit {
	TONNE = 'TONNE',
	KUBIKMETER = 'KUBIKMETER'
}
